(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('TempCustomerSector', TempCustomerSector);

    TempCustomerSector.$inject = ['$resource', 'DateUtils'];

    function TempCustomerSector ($resource, DateUtils) {
        var resourceUrl =  'api/temp-customer-sectors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startedAt = DateUtils.convertLocalDateFromServer(data.startedAt);
                        data.endedAt = DateUtils.convertLocalDateFromServer(data.endedAt);
                        data.issuedDate = DateUtils.convertDateTimeFromServer(data.issuedDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.startedAt = DateUtils.convertLocalDateToServer(data.startedAt);
                    data.endedAt = DateUtils.convertLocalDateToServer(data.endedAt);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.startedAt = DateUtils.convertLocalDateToServer(data.startedAt);
                    data.endedAt = DateUtils.convertLocalDateToServer(data.endedAt);
                    return angular.toJson(data);
                }
            }
        });
    }
})();
